<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ $t(sidebarTitle) }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="">
          <b-col md="12">
            <b-form-group
              :label="$t('Media')"
              :invalid-feedback="$t('Media are required')"
              required
              ref="docs"
            >
              <div class="template-media-upload">
                <div
                  v-if="!hasMediaPreview && !docLoading"
                  class="template-media-upload__slot"
                >
                  <b-img
                    ref="previewEl"
                    src="https://placehold.co/120x120?text=Media"
                    @click="$refs.mediaDoc.click()"
                    style="border-radius: 10px"
                    height="120px"
                    width="120px"
                  />
                </div>

                <div
                  v-else-if="!hasMediaPreview && docLoading"
                  class="template-media-upload__slot"
                >
                  <b-spinner
                    type="grow"
                    :label="$t('Loading') + '...'"
                    variant="primary"
                  />
                </div>

                <div v-else class="template-media-upload__preview">
                  <b-img
                    v-if="isMediaImage()"
                    ref="previewEl"
                    :src="mediaPreviewSrc"
                    referrerpolicy="no-referrer"
                    @error="onMediaPreviewError"
                    @click="!docLoading && $refs.mediaDoc.click()"
                    style="border-radius: 10px; object-fit: cover"
                    height="120px"
                    width="120px"
                  />
                  <video
                    v-else-if="isMediaVideo()"
                    controls
                    controlslist="nodownload"
                    style="height: 120px; width: 120px; border-radius: 10px"
                  >
                    <source :src="activeMediaSrc" type="video/mp4" />
                  </video>
                  <a
                    v-else
                    :href="activeMediaSrc"
                    target="_blank"
                    class="media-file-link"
                    :title="mediaDisplayName"
                  >
                    <div class="file-type">{{ mediaTypeLabel }}</div>
                    <span class="media-file-name">{{ mediaDisplayName }}</span>
                  </a>
                  <div v-if="docLoading" class="template-media-upload__overlay">
                    <b-spinner variant="primary" type="grow" />
                  </div>
                  <feather-icon
                    v-if="!docLoading"
                    icon="Trash2Icon"
                    size="22"
                    class="text-danger cursor-pointer template-media-upload__delete"
                    @click="removeMedia()"
                  />
                </div>
                <input
                  type="file"
                  id="mediaDoc"
                  hidden
                  ref="mediaDoc"
                  @change="addMedia()"
                  accept="image/*,.pdf,video/mp4"
                />
              </div>

              <!-- <b-button
                ref="docs"
                @click="$refs.mediaDoc.click()"
                variant="primary"
                :disabled="request || docLoading"
                block
              >
              </b-button> -->
            </b-form-group>
          </b-col>

          <!-- <b-col md="12">
            <b-form-group label="Convert Images to PDF">
              <template #description>
                <div class="text-dark">
                  Select multiple images to convert them into a single PDF
                  document. This will replace any existing media.
                </div>
              </template>
              <div>
                <b-button
                  variant="outline-primary"
                  :disabled="pdfLoading"
                  @click="$refs.imageToPdfInput.click()"
                  block
                  v-b-tooltip.hover.top
                >
                  <template v-if="pdfLoading">
                    <b-spinner small type="grow" class="mr-50" />
                    <span>Converting...</span>
                  </template>
                  <template v-else>
                    <feather-icon icon="ImageIcon" class="mr-50" />
                    <span>Upload Images</span>
                  </template>
                </b-button>
              </div>
              <input
                type="file"
                ref="imageToPdfInput"
                hidden
                multiple
                accept="image/*"
                @change="uploadImages()"
              />
              <div v-if="selectedImages.length > 0" class="mt-25">
                <small class="text-info">
                  Selected {{ selectedImages.length }} image(s) for PDF
                  conversion
                </small>
              </div>
            </b-form-group>
          </b-col> -->

          <b-col md="12">
            <b-form-group
              :label="$t('Title')"
              :invalid-feedback="$t('Title is required')"
            >
              <b-form-input
                :placeholder="$t('Enter title.')"
                ref="title"
                v-model="myObj.title"
                @focusout="CheckTitle()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Message')"
              :invalid-feedback="$t('Message is required.')"
              ref="msg"
            >
              <b-form-textarea
                ref="msg"
                :placeholder="$t('Enter message.')"
                v-model="myObj.message"
                @focusout="CheckMessage()"
                rows="10"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Send on')"
              :invalid-feedback="$t('Send on is required.')"
              ref="send"
            >
              <v-select
                ref="send"
                v-model="myObj.sendOn"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="filteredSendOptions"
                :reduce="(val) => val.value"
                label="text"
                :clearable="false"
                :placeholder="$t('send on')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              @click="Add()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else> {{ $t(sidebarButton) }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-card>
      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4" sm="12" cols="12" v-if="rights.add">
          <b-button
            @click="AddOpen()"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            block
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">{{ $t("Add Template") }}</span>
          </b-button>
        </b-col>

        <b-col
          class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
          xl="10"
          lg="9"
          md="8"
          sm="12"
          cols="12"
        >
          <b-form-group class="">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="filters.length"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :busy="dataLoading"
        show-empty
        responsive
        hover
        :selectable="rights.edit"
        select-mode="single"
        @row-selected="Edit($event[0].id)"
      >
        <template #head()="scope">
          <div>{{ $t(scope.label) }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-5">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
        </template>

        <!-- <template #head(actions)="data">
          <div class="mr-5 text-right">
            <span>{{ $t(data.label) }}</span>
          </div>
        </template> -->

        <template #cell(actions)="data">
          <div class="text-right">
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              v-b-tooltip.hover.top
              :title="$t('Edit')"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="Edit(data.item.id)"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>

            <b-button
              v-if="rights.delete"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              v-b-tooltip.hover.top
              :title="$t('Delete')"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="Delete(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormGroup,
  BForm,
  BSpinner,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BFormTextarea,
  BAvatar,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";

import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import {
  getDocumentDisplayName,
  getDocumentTypeLabel,
  getMediaPreviewUrl,
  getMediaTypeFromMime,
  getUploadPath,
  getUploadedMediaType,
  getUploadedPaths,
  handleDrivePreviewError,
  normalizeDocAttachment,
  uploadToMySkool,
} from "@/utils/gdriveUpload";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BImg,
    BFormGroup,
    BForm,
    BSpinner,
    BSidebar,
    BInputGroupPrepend,
    BInputGroup,
    BFormTextarea,
    BAvatar,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.LoadData();
    }
  },
  computed: {
    filters: function () {
      return this.items.filter((pro) => {
        return (
          pro.title.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.message.toLowerCase().match(this.searchQuery.toLowerCase())
        );
      });
    },
    mediaPreviewSrc() {
      const src = this.activeMediaSrc;
      if (!src) return "";
      if (String(src).startsWith("blob:")) return src;
      const type = this.mediaMeta?.type || "Image";
      return getMediaPreviewUrl(src, type);
    },
    activeMediaSrc() {
      return this.mediaPreview || this.myObj.media || "";
    },
    hasMediaPreview() {
      return Boolean(this.activeMediaSrc);
    },
    mediaTypeLabel() {
      if (this.mediaMeta?.typeLabel) return this.mediaMeta.typeLabel;
      return getDocumentTypeLabel(this.myObj.media);
    },
    mediaDisplayName() {
      if (this.mediaMeta?.name) return this.mediaMeta.name;
      return getDocumentDisplayName(this.myObj.media);
    },
    filteredSendOptions(){
      if (this.reportDomain === 'myskoolhappinessfoundation') {
        return this.otherOptions
      }
      return this.sendOptions;
    }
  },
  data() {
    return {
      rights: {},
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      request: false,
      sidebarTitle: "Add Template",
      sidebarButton: "Save",
      dataLoading: false,
      visibility: false,
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      fields: [
        { label: "title", key: "title" },
        { label: "message", key: "message" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      myObj: {
        id: 0,
        title: "",
        message: "",
        campusID: this.$store.state.userData.cId,
        media: "",
      },
      otherOptions: [
        { text: "None", value: "" },
        { text: "Student (checkin)", value: "present" },
        { text: "Student Absent", value: "absent" },
        { text: "Student Late", value: "late" },
        { text: "Student Leave", value: "leave" },
        { text: "Student (checkout)", value: "timeout" },
        { text: "Staff Attendance (in)", value: "Staff Attendance" },
        {
          text: "Staff Attendance (out)",
          value: "Staff Attendance (out)",
        },
      ],
      sendOptions: [
        { text: "None", value: "" },
        { text: "Fee Challan", value: "Fee Challan" },
        {
          text: "Fee Challan (family-wise)",
          value: "Fee Challan (family-wise)",
        },
        { text: "Defaulters", value: "Defaulters" },
        { text: "Fee Collection", value: "Fee Collection" },
        { text: "Student (checkin)", value: "present" },
        { text: "Student Absent", value: "absent" },
        { text: "Student Late", value: "late" },
        { text: "Student Leave", value: "leave" },
        { text: "Student (checkout)", value: "timeout" },
        { text: "Staff Attendance (in)", value: "Staff Attendance" },
        {
          text: "Staff Attendance (out)",
          value: "Staff Attendance (out)",
        },
        { text: "Examination", value: "Examination" },
        { text: "Inquiry", value: "Inquiry" },
        { text: "Admission", value: "Admission" },
        { text: "Salary Slip", value: "Salary slip" },
        { text: "Result", value: "Result" },
        { text: "Subject Marks", value: "subject marks" },
        { text: "Subject Marks (Absent)", value: "subject marks (Absent)" },
      ],
      docLoading: false,
      pdfLoading: false,
      selectedImages: [],
      mediaMeta: null,
      mediaPreview: "",
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    syncMediaMeta(originalName) {
      if (!this.myObj.media) {
        this.mediaMeta = null;
        return;
      }
      const doc = normalizeDocAttachment(this.myObj.media);
      const name =
        originalName || getDocumentDisplayName(this.myObj.media);
      this.mediaMeta = {
        type: doc.type,
        name,
        typeLabel: getDocumentTypeLabel(this.myObj.media, name),
      };
    },
    isMediaImage() {
      if (!this.hasMediaPreview) return false;
      const type = String(
        this.mediaMeta?.type || normalizeDocAttachment(this.activeMediaSrc).type
      ).toLowerCase();
      if (type === "image") return true;
      if (
        (type === "file" || !this.mediaMeta) &&
        /export=view|googleusercontent\.com/i.test(this.activeMediaSrc)
      ) {
        return true;
      }
      return false;
    },
    isMediaVideo() {
      if (!this.hasMediaPreview) return false;
      const type = String(
        this.mediaMeta?.type || normalizeDocAttachment(this.activeMediaSrc).type
      ).toLowerCase();
      return type === "video";
    },
    onMediaPreviewError(event) {
      handleDrivePreviewError(event, this.activeMediaSrc, "image");
    },
    clearMediaPreview() {
      if (
        this.mediaPreview &&
        String(this.mediaPreview).startsWith("blob:")
      ) {
        URL.revokeObjectURL(this.mediaPreview);
      }
      this.mediaPreview = "";
    },

    async Edit(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "MessageTemplate/GetSelected?id=" +
          id +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      this.myObj = await this.get(obj);
      this.clearMediaPreview();
      this.syncMediaMeta();
      // console.log("editObj:", this.myObj);

      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["msg"];
      elem.state = undefined;

      this.sidebarTitle = "Edit Template";
      this.sidebarButton = "Update";
      this.visibility = true;
    },

    AddOpen() {
      this.myObj = {
        id: 0,
        title: "",
        message: "",
        sendOn: "",
        media: "",
        campusID: this.$store.state.userData.cId,
      };
      this.mediaMeta = null;
      this.clearMediaPreview();

      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["msg"];
      elem.state = undefined;

      this.sidebarTitle = "Add Template";
      this.sidebarButton = "Save";
      this.visibility = true;
    },

    CheckTitle() {
      var elem = this.$refs["title"];
      if (this.myObj.title == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckMessage() {
      var elem = this.$refs["msg"];
      if (this.myObj.message == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    removeMedia() {
      this.clearMediaPreview();
      this.myObj.media = null;
      this.mediaMeta = null;
      if (this.$refs.mediaDoc) this.$refs.mediaDoc.value = "";
    },
    async addMedia() {
      let media = this.$refs.mediaDoc.files[0];
      if (!media) return;

      this.clearMediaPreview();
      this.docLoading = true;
      const localPreview = URL.createObjectURL(media);
      this.mediaPreview = localPreview;
      const previewType = getMediaTypeFromMime(media.type) || "File";
      this.mediaMeta = {
        type: previewType,
        name: media.name,
        typeLabel: getDocumentTypeLabel(media.name, media.name),
      };

      try {
        const uploaded = await uploadToMySkool([media]);
        const item = uploaded[0];
        const path = getUploadPath(item);
        URL.revokeObjectURL(localPreview);
        this.mediaPreview = "";
        this.myObj.media = path;
        this.mediaMeta = {
          type: getUploadedMediaType(item),
          name:
            item.originalname ||
            item.originalName ||
            getDocumentDisplayName(path),
          typeLabel: getDocumentTypeLabel(
            path,
            item.originalname || item.originalName
          ),
        };
      } catch (err) {
        URL.revokeObjectURL(localPreview);
        this.clearMediaPreview();
        this.myObj.media = null;
        this.mediaMeta = null;
        console.log(err);
      } finally {
        this.docLoading = false;
        if (this.$refs.mediaDoc) this.$refs.mediaDoc.value = "";
      }
    },

    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "MessageTemplate?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
      this.dataLoading = false;
      // console.log("temp", this.items);
    },

    async Add() {
      this.CheckTitle();
      this.CheckMessage();
      if (this.CheckTitle() == false || this.CheckMessage() == false) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.myObj.id == 0) {
          //Add
          this.request = true;
          // console.log("obj:", this.myObj);
          var status = await this.post({
            url:
              this.$store.state.domain +
              "MessageTemplate?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Template added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) this.LoadData();
          this.visibility = false;
        } else {
          //Edit
          this.request = true;
          // console.log("edit_obj:", this.myObj);
          var status = await this.put({
            url:
              this.$store.state.domain +
              "MessageTemplate/" +
              this.myObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Template updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) this.LoadData();
          this.visibility = false;
        }
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "MessageTemplate/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Template removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },

    async uploadImages() {
      const files = this.$refs.imageToPdfInput.files;
      if (files.length === 0) return;

      this.pdfLoading = true;
      this.selectedImages = Array.from(files);

      try {
        const uploaded = await uploadToMySkool(files);
        const imageUrls = getUploadedPaths(uploaded).join(",");
        if (imageUrls) this.convertImagesToPdf(imageUrls);
        else {
          this.$bvToast.toast(
            "Failed to convert images to PDF. Please try again.",
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            }
          );
          this.pdfLoading = false;
          this.selectedImages = [];
        }
      } catch (error) {
        console.error("Error:", error);
        this.$bvToast.toast(
          "Failed to convert images to PDF. Please try again.",
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
        this.pdfLoading = false;
        this.selectedImages = [];
        this.$refs.imageToPdfInput.value = null;
      }
    },

    async convertImagesToPdf(imageUrls) {
      try {
        const pdfResponse = await axios.post(
          "https://images-to-pdf.cloudious.net/generate-pdf",
          {
            images: imageUrls,
          },
          {
            headers: {
              "x-api-key": "sk_live_9f84b1d2a7c04d9bbf0a932c9e6e52b1",
              "Content-Type": "application/json",
            },
          }
        );
        // console.log("pdfResponse:", pdfResponse);

        // Set the PDF URL to myObj.media
        this.myObj.media =
          "https://images-to-pdf.cloudious.net" + pdfResponse.data.pdf_url;
        this.syncMediaMeta("Converted document.pdf");

        this.$bvToast.toast("Images successfully converted to PDF!", {
          title: "Success!",
          variant: "success",
          toaster: "b-toaster-top-center",
        });
      } catch (error) {
        console.error("PDF Conversion Error:", error);
        this.$bvToast.toast(
          "Failed to convert images to PDF. Please try again.",
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } finally {
        this.pdfLoading = false;
        this.selectedImages = [];
        this.$refs.imageToPdfInput.value = null; // Clear selected files
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.file-type {
  background-color: #e62e2d;
  font-family: "Helvetica", sans-serif;
  color: white;
  border-radius: 10px;
  height: 80px;
  width: 80px;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  padding: 8px;
}

.media-file-link {
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 220px;
  text-decoration: none;
}

.media-file-name {
  margin-left: 10px;
  color: #6e6b7b;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.template-media-upload {
  display: flex;
  justify-content: center;
  width: 100%;
}

.template-media-upload__slot {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  min-width: 120px;
}

.template-media-upload__preview {
  position: relative;
  display: flex;
  align-items: center;
}

.template-media-upload__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 10px;
  z-index: 2;
}

.template-media-upload__delete {
  margin-left: 0.5rem;
}
</style>
